<template>
    <img
        height="18"
        width="32"
        src="https://d39xau2r7ekvda.cloudfront.net/application/assets/img/Raynet.png"
    />
</template>
